
import React from "react";
import Separar from "../componentes/Separador NavBar/Separador";
import organigrama from "../imagenes/organigrama.svg";
import "./estilos/Directorio.css";

function Directorio () {
    return(
        <div className="Container-Directorio">
            <Separar />
            <div className="directorio-main">
                <img src={organigrama} alt="Organigrama" className="organigrama-img"/>
            </div>
            <audio src={process.env.PUBLIC_URL + '/corrido_de_nayarit.mp3'} autoPlay />
        </div>
    );
};

export default Directorio;